(function () {
  document.querySelectorAll('.zd-store-search').forEach(function (search) {
    if (search.dataset.searchReady) return;
    search.dataset.searchReady = 'true';
    var trigger = search.querySelector('summary');
    search.addEventListener('toggle', function () {
      if (search.open) search.querySelector('input[name="q"]').focus();
    });
    search.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        search.open = false;
        trigger.focus();
      }
    });
    document.addEventListener('click', function (event) {
      if (search.open && !search.contains(event.target)) search.open = false;
    });
  });
})();
